/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ai-mate.chat-error-banner.description': 'Din chathistorik gemmes i op til 30 dage.',
  'ai-mate.chat-error-banner.title': 'Start ny chat',
  'ai-mate.chat-error.description': 'Prøv at <btn>genindlæse chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Du har nået det maksimale antal anmodninger. Prøv igen senere.',
  'ai-mate.chat-error.rate-limited-title': 'For mange anmodninger',
  'ai-mate.chat-error.rovo-inactive-description':
    'Det ser ud til, at Rovo ikke er aktiveret på dit website. <link>Opsætning af Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo er inaktiv',
  'ai-mate.chat-error.title': 'Vi er ikke sikre på, hvad der gik galt',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Spørg AI om dette',
  'highlight-actions.rovo-chat-explain-option.text': 'Forklar',
  'highlight-actions.rovo-chat-explain-prompt': 'Forklar dette: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Chatanbefalinger',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Åbn Chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Opsummer',
  'highlight-actions.rovo-chat-summarize-prompt': 'Opsummer følgende: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Rul til venstre',
  'horizontal-scroll-container.scroll-right': 'Rul til højre',
};
